import { Store } from '@ngrx/store';
import { Injectable, OnChanges } from '@angular/core';
import { CookieStorage } from './classes/cookie-storage.class';

export type StorageType = 'cookie' | 'local' | 'session';

@Injectable()
export class StorageService {

    public local: Storage = localStorage;
    public cookie: CookieStorage = new CookieStorage();
    public session: Storage = sessionStorage;

    // Static methods for backward compatibility
    public static getLocalItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    public static setLocalItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    public static removeLocalItem(key: string): void {
        localStorage.removeItem(key);
    }

}
